import { EmployeeCoursesReportFilterI } from 'types';
import {
  ReportsLayoutFiltersContainer,
  ResetButton,
  SearchButton,
} from '../EmployeesReportFilters/EmployeesReportFilters.styled';
import { Controller } from 'react-hook-form';
import SearchTextField from 'Components/SeachTextField/SearchTextField';
import useEmployeeCoursesReportFilters from 'Hooks/useEmployeeCoursesReportFilters';
import CustomDatePicker from 'Components/CustomDatePicker/CustomDatePicker';
import CustomSelect from 'Components/CustomSelect/CustomSelect';
import { colors } from 'Constants/Colors';
import useTranslation from 'Hooks/useTranslation';
import { Search } from '@mui/icons-material';

interface Props {
  onSearch: (filters: EmployeeCoursesReportFilterI) => void;
  onFiltersChange?: (filters: EmployeeCoursesReportFilterI) => void;
}

const EmployeeCoursesFilters = ({ onSearch }: Props) => {
  const { control, prioritiesData, categoriesData, handleReset, isDirty, getValues } = useEmployeeCoursesReportFilters({
    onSearch,
  });
  const { t2 } = useTranslation('employees_courses_report');

  return (
    <ReportsLayoutFiltersContainer>
      <Controller
        name="name"
        control={control}
        render={({ field }) => <SearchTextField placeholder={t2('search_course')} {...field} />}
      />

      <Controller
        name="date"
        control={control}
        render={({ field }) => <CustomDatePicker label={t2('evaluation_date')} placeholder="dd/mm/yyyy" {...field} />}
      />

      <Controller
        name="priorityId"
        control={control}
        render={({ field }) => (
          <CustomSelect
            placeholder={t2('priority')}
            options={prioritiesData?.map(priority => ({
              value: priority.id,
              label: priority.name,
            }))}
            {...field}
            onChange={value => {
              field.onChange(value);
            }}
          />
        )}
      />

      <Controller
        name="categoryId"
        control={control}
        render={({ field }) => (
          <CustomSelect
            placeholder={t2('category')}
            options={categoriesData?.map(category => ({
              value: category.id,
              label: category.name,
            }))}
            {...field}
            onChange={value => {
              field.onChange(value);
            }}
          />
        )}
      />

      <SearchButton
        variant="outlined"
        color="success"
        hidden={!isDirty}
        startIcon={<Search />}
        onClick={() => {
          const values = getValues();
          onSearch(values);
        }}
      >
        {t2('search')}
      </SearchButton>

      {isDirty && (
        <ResetButton
          onClick={handleReset}
          variant="outlined"
          style={{
            color: colors.RED,
            borderColor: colors.RED,
            textTransform: 'none',
            height: '50px',
            minWidth: '100px',
          }}
        >
          {t2('clear_filters')}
        </ResetButton>
      )}
    </ReportsLayoutFiltersContainer>
  );
};

export default EmployeeCoursesFilters;
